import { distToSegmentSq } from './geometry.ts';

/**
 * Ramer–Douglas–Peucker simplification of a flat [x0, y0, x1, y1, …]
 * polyline (spec §5.5). Iterative, so long strokes can't overflow the stack.
 */
export function simplify(points: readonly number[], tolerance: number): number[] {
  const n = points.length >> 1;
  if (n <= 2) return points.slice();
  const keep = new Uint8Array(n);
  keep[0] = keep[n - 1] = 1;
  const tol2 = tolerance * tolerance;
  const stack: [number, number][] = [[0, n - 1]];
  while (stack.length) {
    const [a, b] = stack.pop()!;
    const ax = points[a * 2]!, ay = points[a * 2 + 1]!, bx = points[b * 2]!, by = points[b * 2 + 1]!;
    let max = -1, index = -1;
    for (let i = a + 1; i < b; i++) {
      const d = distToSegmentSq(points[i * 2]!, points[i * 2 + 1]!, ax, ay, bx, by);
      if (d > max) { max = d; index = i; }
    }
    if (max > tol2) {
      keep[index] = 1;
      stack.push([a, index], [index, b]);
    }
  }
  const out: number[] = [];
  for (let i = 0; i < n; i++) if (keep[i]) out.push(points[i * 2]!, points[i * 2 + 1]!);
  return out;
}
